// 创建axios实例
import axios from "axios"
import Qs from 'qs'
import { Loading, MessageBox } from "element-ui";
import { message } from '../util/message';
import { Logout } from './system/header';
import router from "../router";
import JSONbig from 'json-bigint';

let loading        //定义loading变量

function startLoading() {    //使用Element loading-start 方法
  loading = Loading.service({
    lock: true,
    text: '',
    background: 'rgba(0, 0, 0, 0)'
  })
}

function endLoading() {    //使用Element loading-close 方法
  loading.close()
}

//那么 showFullScreenLoading() tryHideFullScreenLoading() 要干的事儿就是将同一时刻的请求合并。
//声明一个变量 needLoadingRequestCount，每次调用showFullScreenLoading方法 needLoadingRequestCount + 1。
//调用tryHideFullScreenLoading()方法，needLoadingRequestCount - 1。needLoadingRequestCount为 0 时，结束 loading。
let needLoadingRequestCount = 0

export function showFullScreenLoading() {
  if (needLoadingRequestCount === 0) {
    startLoading()
  }
  needLoadingRequestCount++
}

export function tryHideFullScreenLoading() {
  if (needLoadingRequestCount <= 0) return
  needLoadingRequestCount--
  if (needLoadingRequestCount === 0) {
    endLoading()
  }
}

const service = axios.create({
  baseURL: process.env.BASE_API,
  timeout: 20000, // 请求超时时间
  transformResponse: [function (data) {
    try {
      return JSONbig({ storeAsString: true }).parse(data);
      // return JSON.parse(data);

    } catch (e) {
      return data;
    }
  }]
});
const code = {
  BM000505: 'BM000505',//token无效或已过期
  BM000504: 'BM000504',//token为空
  BM000503: 'BM000503',//您的用户已在其他设备上登录，请重新登录
};
service.defaults.headers.post["Content-Type"] = "application/json";
// request拦截器
service.interceptors.request.use(config => {
  config.headers['ticket'] = new Date().getTime();
  //config.headers['deviceType']=2;
  const token = storage.get('token');
  if (token) {
    config.headers['Authorization'] = storage.token;
  }
  if (config.method === "post") {
    config.headers["Content-Type"] !== "multipart/form-data" && !Array.isArray(config.data) && (config.data = Qs.parse(config.data));

  } else if (config.method === "get") {

  }
  if (config.headers['load'] == undefined || config.headers['load'] == null || config.headers['load'] == '') {
    showFullScreenLoading();
  }

  return config;
}, error => {
  tryHideFullScreenLoading();
  Promise.reject(error);
});

// respone拦截器
service.interceptors.response.use(response => {
  tryHideFullScreenLoading();
  const { config, data, headers } = response
  const res = response.data;
  if (config.responseType == "blob") {
    if (config.headers["Authorization"] == null) {
      storage.remove('token');
      router.replace({ path: '/login' })
    }
    return { headers, data };
  }
  if (config.params && config.params.excelPath) { // 特殊处理excel转pdf流，todo 扩展
    return res;
  }
  if (res.code !== "000000") {
    // if(!errorCode.includes(res.code)){
    //   message.warning(res.msg)
    // }
    message.warning(res.msg)
    if (res.code === code.BM000505 || res.code === code.BM000503 || res.code === code.BM000504) {
      storage.remove('token');
      router.replace({ path: '/login' })
    }
    return Promise.reject(res.msg);
  } else {
    return res;
  }
},
  error => {
    tryHideFullScreenLoading();
    let status = undefined;
    if (error.response) {
      status = error.response.status
    }
    const map = new Map([
      [undefined, '网络连接出现异常'],
      [400, '缺少请求参数'],
      [405, '请求类型错误'],
      [422, '请求格式正确，但是由于含有语义错误，无法响应'],
      [404, '接口不存在'],
      [408, '连接服务器超时'],
      [415, '发送数据库格式错误'],
      [502, '服务器内部错误,请联系网站管理员']
    ])
    message.error(map.get(status))
    //     MessageBox.confirm(map.get(status),'提示',{
    //   confirmButtonText: '确定',
    //   beforeClose:(action,instance,done)=>{
    //    // done()
    //   }
    // }).then(() => {
    //    //Logout()
    // })
    return;
    return Promise.reject(error);
  }
);
service.all = axios.all
export default service;



// WEBPACK FOOTER //
// ./src/api/axiosConfig.js